import { createQueryKeys } from '@shared/api';

export const portfolioKeys = createQueryKeys('portfolio');
